module.exports = __webpack_public_path__ + "static/media/400027_01.0b9f8963.png";